// // import React from 'react';
// // import { Outlet } from 'react-router-dom';
// // import '../App.css';

// // function LayoutWithoutDash() {
// //   return (
// //     <div className="container">
// //       {/* <header className="header">Header without Dashboard</header> */}
// //       <main className="main">
// //         <Outlet />
// //       </main>
// //       {/* <footer className="footer">Footer content</footer> */}
// //     </div>
// //   );
// // }

// export default LayoutWithoutDash;

// LayoutWithoutDash.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import '../App.css';

const LayoutWithoutDash = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default LayoutWithoutDash;
